module.exports = __webpack_public_path__ + "static/li-auto-2-1200x624-c8ef012fca7926dfddfabb4d2d95e495.jpg";